import { render, staticRenderFns } from "./TaskModuleRulesRuleAdded.vue?vue&type=template&id=732747f4&scoped=true"
import script from "./TaskModuleRulesRuleAdded.vue?vue&type=script&lang=js"
export * from "./TaskModuleRulesRuleAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732747f4",
  null
  
)

export default component.exports